import React from "react";
import { BiCaretDown } from "@react-icons/all-files/bi/BiCaretDown";
import { Disclosure, Transition } from "@headlessui/react";

const Faq = ({ data }) => {
  const CollapseItem = ({ title, content }) => {
    return (
      <Disclosure>
        {({ close, open }) => (
          <div className=" border-solid border-2 rounded mb-2 ">
            <Disclosure.Button className={"w-full text-left"}>
              <div
                className={
                  "cursor-pointer flex items-center justify-between px-7 py-4 hover:bg-[#dedede] transition" +
                  (open ? "bg-white " : "bg-[#f7f7f7] ")
                }
              >
                <span className="font-semibold text-15 text-brand-black flex-1">
                  {title}
                </span>
                <BiCaretDown
                  className={
                    "text-orange transform transition-transform  " +
                    (open ? "rotate-180" : "")
                  }
                  size="25"
                />
              </div>
            </Disclosure.Button>
            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <Disclosure.Panel>
                <div
                  className="opacity-50 text-sm text-brand-black px-7 pb-8 pt-4"
                  dangerouslySetInnerHTML={{ __html: content }}
                ></div>
              </Disclosure.Panel>
            </Transition>
          </div>
        )}
      </Disclosure>
    );
  };

  return (
    <div className="mb-8">
      {data.map((item, key) => (
        <CollapseItem
          key={key}
          title={item.baslik}
          content={item.icerik}
        ></CollapseItem>
      ))}
    </div>
  );
};

export default Faq;
